import { SelectFieldOption } from 'types';
import ReactSelect from './ReactSelect';

interface MockReactSelectProps {
  id: string;
  name: string;
  className: string;
  classNamePrefix: string;
  onChange: (
    value: SelectFieldOption | undefined,
    event: { name: string; isNonUserAction: boolean }
  ) => void;
  onFocus: () => void;
  onBlur: () => void;
  options: SelectFieldOption[];
  isDisabled: boolean;
  menuShouldScrollIntoView: boolean;
  value: SelectFieldOption;
  minMenuHeight: number;
}

export function _MockReactSelect(
  props: MockReactSelectProps
): React.ReactElement {
  const {
    name,
    value,
    options,
    onChange,
    onFocus,
    onBlur,
    isDisabled,
    className,
  } = props;

  return (
    <select
      name={name}
      data-testid={name}
      value={value ? value.value : ''}
      onChange={(e) =>
        onChange(
          options.find((option) => option.value === e.target.value),
          { name, isNonUserAction: false }
        )
      }
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={isDisabled}
      className={className}
    >
      {options.map((option) => (
        <option
          key={option.value}
          value={option.value}
          data-testid={option.value}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}

export function MockReactSelect(
  props: MockReactSelectProps
): React.ReactElement {
  return (
    <ReactSelect {...props} SelectComponent={_MockReactSelect} hasDefault />
  );
}
